(function () {
  'use strict';

  function initCard(card) {
    if (card.dataset.mndfrmeCardReady === 'true') return;
    card.dataset.mndfrmeCardReady = 'true';
    var dots = card.querySelectorAll('.mndfrme-pcard__dot');
    if (!dots.length) return;

    var mainImg = card.querySelector('.mndfrme-pcard__img--main');
    var hoverImg = card.querySelector('.mndfrme-pcard__img--hover');
    var link = card.querySelector('.mndfrme-pcard__link');

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var imgSrc = dot.getAttribute('data-img');
        var hoverSrc = dot.getAttribute('data-hover-img');
        var variantUrl = dot.getAttribute('data-url');

        if (mainImg && imgSrc) {
          mainImg.src = imgSrc;
          if (mainImg.srcset) mainImg.srcset = '';
        }
        if (hoverImg && hoverSrc) {
          hoverImg.src = hoverSrc;
          if (hoverImg.srcset) hoverImg.srcset = '';
        }
        if (link && variantUrl) {
          link.href = variantUrl;
          link.setAttribute('aria-label', link.getAttribute('aria-label'));
        }

        dots.forEach(function (d) {
          d.classList.remove('is-active');
          d.setAttribute('aria-pressed', 'false');
        });
        dot.classList.add('is-active');
        dot.setAttribute('aria-pressed', 'true');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-js-swatch]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-js-swatch]').forEach(initCard);
  });
})();
